import { Actions, createEffect, Effect, ofType } from '@ngrx/effects';
import { Inject, Injectable } from '@angular/core';
import { SearchDataModel } from './search-data.model';
import {
  SessionStorageDataModel,
  SessionStorageService,
} from '@shared/services/session-storage/session-storage.service';
import { tap } from 'rxjs/operators';
import { TypedAction } from '@ngrx/store/src/models';
import * as SearchDataActions from './search-data.actions';

@Injectable({
  providedIn: 'root',
})
export class SearchDataEffects {
  constructor(
    private actions$: Actions, 
    @Inject(SessionStorageService) private _sessionStorage: SessionStorageService
  ) { }

  @Effect({ dispatch: false })
  searchDataEffect$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SearchDataActions.setSearchData),
        tap((response: SearchDataModel & TypedAction<string>) => {
          if (this._sessionStorage.storage) {
            const currentSessionData = this._sessionStorage.storage.SESSION_STORAGE;
            
            if (this._sessionStorage.isUserEditingFlights()) {
              
              const preservedFlightLeg = currentSessionData?.searchData?.flightLeg || [];
              const newSearchData = { ...response.data };
              
              if (newSearchData.flightLeg && preservedFlightLeg.length > 0) {
                newSearchData.flightLeg = newSearchData.flightLeg.map(newLeg => {
                  const userModifiedLeg = preservedFlightLeg.find(preserved => preserved.legNumber === newLeg.legNumber);
                  
                  if (userModifiedLeg) {
                    return {
                      ...newLeg,
                      departureDate: userModifiedLeg.departureDate
                    };
                  }
                  return newLeg;
                });
              }
              
              this._sessionStorage.storage.SESSION_STORAGE = {
                ...currentSessionData,
                searchData: newSearchData,
              } as SessionStorageDataModel;
              
            } else {
              this._sessionStorage.storage.SESSION_STORAGE = {
                ...currentSessionData,
                searchData: response.data,
              } as SessionStorageDataModel;
            }
          }
        })
      ),
    { dispatch: false }
  );
}